import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { BulkUpdateTeamServiceConstants } from "./bulk-update-team.service.constants";
import { ApiTeamConstants } from "../../../constants/api-constants/api-team.constants";
let BulkUpdateTeamService = class BulkUpdateTeamService {
    http;
    componentName = BulkUpdateTeamServiceConstants.COMPONENT_NAME;
    constructor(http) {
        this.http = http;
    }
    postBulkUpdateTeam(params) {
        return this.http.post(`${ApiTeamConstants.URL}/${ApiTeamConstants.FUNCTION_BULK_REASSIGN_TEAM_MEMBER}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
BulkUpdateTeamService = __decorate([
    Injectable({
        providedIn: "root"
    })
], BulkUpdateTeamService);
export { BulkUpdateTeamService };
